import { useContext } from 'react'

import { MagazineContext } from 'src/components/molecules/MagazineProvider'

export const useMagazineContext = () => {
  return useContext(MagazineContext)
}
